import React from 'react';
import {
  string, array,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';
import OrderLines from '../OrderLines';
import OrderAmounts from '../OrderAmounts';
import getFieldConfig from './getFieldConfig';
import OrderLineTitle from '../OrderLineTitle';

const OrderLineGroups = ({
  orderLineGroups,
  identifier,
  currencyCode,
  isShowButtonCol,
  orderLineFieldsConfig,
  ...rest
}) => {
  if (orderLineGroups.length === 0) {
    return null;
  }
  const fieldConfig = orderLineFieldsConfig?.orderAmountFieldConfig || getFieldConfig(isShowButtonCol);
  return (
    <div className="orderline-groups">
      <OrderLineTitle
        className="orderline-groups__title"
        descriptionTitleId={'checkout.lib.components.common.text.orders'}
        amountTitleId={'checkout.lib.components.orderDetailContent.amountTitle'}
        orderLineFieldsConfig={orderLineFieldsConfig}
        isShowButtonCol={isShowButtonCol}/>
      <div className="orderline-groups__content">
        {
          orderLineGroups.map(({
            orderLines, soldBy,
            aaDiscount, cancellationFee, processingFee,
            surchargeGroup, totalAmount,
          }, idx) => {
            const groupAmounts = omitBy({
              aaDiscount,
              cancellationFee,
              processingFee,
              surchargeGroup,
              totalAmount,
            }, isUndefined);
            return (
              <div key={idx} className="orderline-groups__item">
                {
                  soldBy && <div className="orderline-groups__item__title">
                    <span className="title-number">{idx + 1}</span>
                    <span className="title-content">
                      <Locale id="checkout.lib.components.text.soldBy" params={{ 0: soldBy }}/>
                    </span>
                  </div>
                }
                <OrderLines
                  currencyCode={currencyCode}
                  orderLines={orderLines}
                  checkoutOrderIdentifier={identifier}
                  isShowButtonCol={isShowButtonCol}
                  orderLineFieldsConfig={orderLineFieldsConfig}
                  {...rest} />
                { !isEmpty(groupAmounts)
              && <div className="orderline-groups__item__amount">
                <div className="hr-solid-line" />
                <OrderAmounts
                  currencyCode={currencyCode}
                  isShowBlankCol={isShowButtonCol}
                  fieldConfig={fieldConfig}
                  {...groupAmounts}/>
              </div>
                }
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

OrderLineGroups.propTypes = {
  orderLineGroups: array,
  identifier: string,
};

OrderLineGroups.defaultProps = {
  orderLineGroups: [],
};

export default OrderLineGroups;
